// @flow
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandMore from '@material-ui/icons/ExpandMore';
import React from 'react';
import styled from 'styled-components';
import { purple } from '../../style/colors';
import type { ListItemType } from '../../types';

type Props = {
  list: Array<ListItemType>,
};

type State = {
  open: ?string,
};

export default class ExpandableList extends React.Component<Props, State> {
  state = { open: null };

  handleOpen = (name: string) =>
    this.setState(state => ({ ...state, open: name }));

  handleClose = () => this.setState(state => ({ ...state, open: null }));

  toggle = (name: string) => {
    const { open } = this.state;
    if (open === name) return this.handleClose();
    return this.handleOpen(name);
  };

  isOpen = (name: string) => this.state.open === name;

  render() {
    const { list } = this.props;
    return (
      <StyledList>
        {list.map(item => {
          const isOpen = this.isOpen(item.name);
          return (
            <FullListItem key={item.name} open={isOpen}>
              <ListItem button onClick={() => this.toggle(item.name)}>
                <StyledListItemText
                  primary={item.name}
                  secondary={item.shortDescription}
                  open={isOpen}
                />
                <ListItemSecondaryAction>
                  <IconButton onClick={() => this.toggle(item.name)}>
                    <StyledExpandMore open={isOpen} />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Collapse in={isOpen} timeout={500}>
                <Content>{item.children}</Content>
              </Collapse>
            </FullListItem>
          );
        })}
      </StyledList>
    );
  }
}

const StyledList = styled(List)`
  && {
    background: #f6f9fc;
    max-width: 900px;
    margin: 60px auto;
  }
`;

const StyledExpandMore = styled(ExpandMore)`
  && {
    transition: all 0.5s ease;
    ${props => props.open && `transform: rotate(180deg);`};
  }
`;

const FullListItem = styled.div`
  && {
    transition: background-color 1s ease;
    background: #f6f9fc;
    ${props => props.open && 'background: #d9e2ea;'};
  }
`;

const Content = styled.div`
  && {
    padding: 12px 16px;
  }
`;

const StyledListItemText = styled(ListItemText)`
  && {
    h3 {
      ${props => props.open && `color: ${purple[500]};`};
    }
  }
`;
